const { getElement, waitForConsentSettingsAvailability } = window.BAO.Utils

class TagalysRecommendations extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    if (window?.onTagalysReady && this.widgetId) {
      // eslint-disable-next-line no-undef
      onTagalysReady(() => {
        waitForConsentSettingsAvailability(() => {
          this.fetchTagalysRecommendations()
        })
      })
    }
  }

  async fetchTagalysRecommendations () {
    try {
      const response = await this.getTagalysRecommendations()
      if (response?.products?.length > 0) {
        const cards = await this.createProductCards(response.products)
        this.renderCarousel(cards)
        window.yotpoWidgetsContainer.initWidgets(false)
      }
    } catch (error) {
      this.handleError(error)
    }
  }

  getTagalysRecommendations () {
    const productIds = this.dataset.productId.split(',')

    return new Promise((resolve, reject) => {
      window.Tagalys.APIConnector.Recommendations.call({
        params: {
          recommendationId: this.widgetId,
          count: this.limit,
          productIds,
        },
        onSuccess: response => resolve(response),
        onFailure: error => reject(error),
      })
    })
  }

  async createProductCards (products) {
    const cards = await Promise.all(
      products.map(async product => {
        const productUrl = `${window.Shopify.routes.root}products/${product.handle}`

        try {
          const res = await window.BAO.sectionRenderer.fetchSingle(
            'product-card',
            productUrl,
          )
          const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
          const article = newDOM.querySelector('article')

          return article
            ? `
          <div class="sec-ProductCarousel_ProductListItem keen-slider__slide" data-product-carousel-el="slide">
            ${article.outerHTML}
          </div>`
            : ''
        } catch (error) {
          this.handleError(error)
          return ''
        }
      }),
    )

    return cards.join('')
  }

  renderCarousel (cards) {
    const sliderClass = this.viewportWidth < 768 ? '' : 'keen-slider'

    const targetEl = getElement('.sec-ProductCarousel_ProductListContainer', {
      context: this,
    })
    const arrows = getElement('#arrows', { context: this })
    targetEl.innerHTML = `
      <product-carousel>
        <div class="sec-ProductCarousel_ProductList ${sliderClass}" data-product-carousel-el="slider">
          ${cards}
        </div>

        ${arrows.innerHTML}
      </product-carousel>
    `

    if (window.vennApps === true) {
      window.BAO.Utils.urlParametersPersistToLinks()
    }
  }

  handleError (error) {
    console.error('Error:', error)
  }

  get limit () {
    return this.dataset.limit || 8
  }

  get widgetId () {
    return this.dataset.widgetId || ''
  }

  get viewportWidth () {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    )
  }
}

if (!customElements.get('tagalys-recommendations')) {
  customElements.define('tagalys-recommendations', TagalysRecommendations)
}
